import PropTypes from 'prop-types';

// prettier-ignore
export const COLUMN_SIZE_PROPTYPE = PropTypes.oneOf([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]);
